import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchContainer"},[_c(VTextField,{attrs:{"label":_vm.$t('WorkspaceEdit.addApps.search'),"prepend-inner-icon":"action_search","hide-details":""},nativeOn:{"input":function($event){return _vm.$emit('change')}},model:{value:(_vm.snippet),callback:function ($$v) {_vm.snippet=$$v},expression:"snippet"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }